import React from 'react';
import { Link } from 'react-router-dom';
import { Urls } from 'data';
import { Button } from 'components/ui/button';
import aglo from 'assets/img/logo/aglo.png';
import logo from 'assets/img/logo/icon_ehadj_green.svg';

const Navbar = () => (
  <header className="sticky top-0 z-20 border-b border-[#e4e6df] bg-white">
    <a className="absolute -top-[100px] left-3 bg-white px-4 py-2 focus:top-2" href="#landing-content">
      Aller au contenu
    </a>
    <div className="mx-auto w-[calc(100%-40px)] min-[681px]:w-[calc(100%-56px)] min-[1001px]:w-[calc(100%-112px)] grid min-h-[82px] grid-cols-[minmax(0,1fr)_auto] items-center gap-2.5 py-3 min-[681px]:grid-cols-[1fr_auto_1fr] min-[681px]:gap-6 min-[681px]:py-0 max-w-[1248px]">
      <img
        className="h-auto w-[170px] max-w-full min-[681px]:w-[180px] min-[1001px]:w-[210px]"
        src={aglo}
        alt="AGLO — Agence pour la gestion de la logistique des officiels"
      />
      <Link className="flex items-center" to={Urls.base} aria-label="eHadj — Accueil">
        <div className="flex items-center gap-2">
          <img src={logo} alt="eHadj" className="h-8 w-8 object-contain" />
          <span className="-mb-1 text-2xl font-bold text-green-800">eHadj</span>
        </div>
      </Link>
      <nav
        className="col-span-full flex items-center justify-center gap-[15px] text-sm min-[681px]:col-auto min-[681px]:justify-end min-[1001px]:gap-[25px]"
        aria-label="Compte pèlerin"
      >
        <Link to={Urls.front.login}>Connexion</Link>
        <Button
          asChild
          className="h-auto min-h-[42px] whitespace-normal bg-[#00543b] px-6 py-2.5 text-white hover:bg-[#003e2b]"
        >
          <Link to={Urls.register}>S’inscrire</Link>
        </Button>
      </nav>
    </div>
  </header>
);
export default Navbar;
